import { CursiveRecorder } from '@root/utils/electron';
import { trackEvent } from '@root/utils/tracking';
import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogMain } from 'stylus-ui/Dialog';

export interface DeleteScribeModalProps {}

const onFollowStepsClicked = () => {
  const link = 'https://scribehow.com/shared/How_to_install_the_new_Scribe_desktop_application___6FLw0QASIOms86FkCYp6w';

  trackEvent('windows_electron_app_phase_out_follow_steps_clicked');
  CursiveRecorder().openURLInBrowser(link);
};

const onSupportEmailClicked = () => {
  const link = 'mailto:support@scribehow.com';

  trackEvent('windows_electron_app_phase_out_support_email_clicked');
  CursiveRecorder().openURLInBrowser(link);
};

const WindowsAppPhaseOutModal: React.FunctionComponent<DeleteScribeModalProps> = ({}) => {
  useEffect(() => {
    trackEvent('windows_electron_app_phase_out_modal_shown');
  }, []);
  return (
    <Dialog open>
      <DialogContent className='min-w-[600px]'>
        <DialogHeader title='Application out of date' hideClose description='This version of Scribe Desktop is no longer supported.' />
        <DialogMain>
          <div className='text-md pb-5 leading-6'>
            Please follow{' '}
            <span className='cursor-pointer text-indigo-700 underline' onClick={onFollowStepsClicked}>
              these steps
            </span>{' '}
            to install the latest version and gain access to the latest and greatest features.
            <br />
            <br />
            For support, please contact{' '}
            <span className='cursor-pointer text-indigo-700 underline' onClick={onSupportEmailClicked}>
              support@scribehow.com
            </span>
            .
          </div>
        </DialogMain>
      </DialogContent>
    </Dialog>
  );
};

export default WindowsAppPhaseOutModal;
